import { FC } from 'react';
import classNames from 'classnames/bind';
import Typography from '@components/common/typography';
import { Icon } from '@components/icons';
import TableTag from '@components/table_tag';
import RangeDatePicker from '@components/range_date_picker';
import styles from './styles.module.scss';
import { getDisableFeature } from '@utils/index';

type SortDir = 'newest' | 'oldest';

const ORDER_STATUS_CHIPS: { label: string; value: string }[] = [
    { label: 'Paid', value: 'succeeded' },
    { label: 'Pending', value: 'pending' },
    { label: 'Canceled', value: 'cancelled' },
    { label: 'Refunded', value: 'refunded' },
    { label: 'Partially refunded', value: 'partially_refunded' }
];

const cx = classNames.bind(styles);

interface IProps {
    toggleFilter: () => void;
    dateFrom: string;
    dateTo: string;
    statusChips: string[];
    sortDir: SortDir;
    onDateFrom: (v: string) => void;
    onDateTo: (v: string) => void;
    onToggleStatus: (v: string) => void;
    onSortDir: (v: SortDir) => void;
}

const FilterOrderSection: FC<IProps> = ({
    toggleFilter,
    dateFrom,
    dateTo,
    statusChips,
    sortDir,
    onDateFrom,
    onDateTo,
    onToggleStatus,
    onSortDir
}) => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.title_wrapper}>
                <Typography variant="h4">Filters</Typography>
                <button
                    type="button"
                    className={styles.close_btn}
                    onClick={toggleFilter}
                    aria-label="Close filters">
                    <Icon name="close" />
                </button>
            </div>
            <div className={styles.block_wrapper}>
                <RangeDatePicker
                    values={[dateFrom || null, dateTo || null]}
                    onChange={(val) => {
                        onDateFrom(val?.[0] ?? '');
                        onDateTo(val?.[1] ?? '');
                    }}
                    maxDate={getDisableFeature()}
                    isDisableFeature
                    full
                    label="Date range"
                />
            </div>
            <div className={styles.block_wrapper}>
                <Typography variant="body3" weight="semibold">
                    Status
                </Typography>
                <div className={styles.tags_wrapper}>
                    {ORDER_STATUS_CHIPS.map((chip) => (
                        <TableTag
                            key={chip.value}
                            isActive={statusChips.includes(chip.value)}
                            onClick={() => onToggleStatus(chip.value)}>
                            {chip.label}
                        </TableTag>
                    ))}
                </div>
            </div>
            <div className={styles.block_wrapper}>
                <Typography variant="body3" weight="semibold">
                    Sort by
                </Typography>
                <div
                    role="radiogroup"
                    aria-label="Sort by"
                    className={styles.radio_group}>
                    <button
                        type="button"
                        role="radio"
                        aria-checked={sortDir === 'newest'}
                        className={cx('radio_option', { radio_active: sortDir === 'newest' })}
                        onClick={() => onSortDir('newest')}>
                        Date: Newest first
                    </button>
                    <button
                        type="button"
                        role="radio"
                        aria-checked={sortDir === 'oldest'}
                        className={cx('radio_option', { radio_active: sortDir === 'oldest' })}
                        onClick={() => onSortDir('oldest')}>
                        Date: Oldest first
                    </button>
                </div>
            </div>
        </div>
    );
};

export default FilterOrderSection;
